export enum DiscoverListTypeEnum {
    targetingList = 'TARGETING_LIST',
    targetingSearch = 'TARGETING_SEARCH',
    distribution = 'DISTRIBUTION',
    none = 'NONE'
}
